const flatten = (obj, name, stem) => {
  let out = {};
  const newStem =
    typeof stem !== 'undefined' && stem !== '' ? stem + '[' + name + ']' : name;

  if (typeof obj !== 'object') {
    out[newStem] = obj;
    return out;
  }

  for (const p in obj) {
    const prop = flatten(obj[p], p, newStem);
    out = merge([out, prop]);
  }
  return out;
};

const merge = objects => {
  const out = {};

  for (let i = 0; i < objects.length; i++) {
    for (let p in objects[i]) {
      out[p] = objects[i][p];
    }
  }

  return out;
};

export default flatten;



// WEBPACK FOOTER //
// ./src/utils/flatten.js